import React from "react";

type Stats = {
    totalClients: number;
    inProgressDeals: number;
    completedDeals: number;
    completedDealsPropertyPriceSum: number;
};

type Props = {
    stats: Stats;
};

const StatCard: React.FC<{ label: string; value: number | string }> = ({
                                                                           label,
                                                                           value,
                                                                       }) => (
    <div className="border rounded p-3">
        <div className="text-xs text-gray-500">{label}</div>
        <div className="text-xl font-semibold">{value}</div>
    </div>
);

export const StatsPanel: React.FC<Props> = ({ stats }) => {
    const formattedVolume = new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        maximumFractionDigits: 0,
    }).format(stats.completedDealsPropertyPriceSum);

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <StatCard label="Загружено клиентов" value={stats.totalClients} />
            <StatCard label="Сделок в работе" value={stats.inProgressDeals} />
            <StatCard label="Завершённых сделок" value={stats.completedDeals} />
            <StatCard label="Объём завершённых сделок" value={formattedVolume} />
        </div>
    );
};
